export enum ModalityType {
  AudioVideo = 'AudioVideo',
  AudioVideoUnify = 'AudioVideoUnify',
  InstantMessaging = 'InstantMessaging',
  ExternalTask = 'ExternalTask',
  Email = 'Email',
  None = 'None',
}
